window.onload = function() { 

  /** multicolumn , read more */
  const readMorBtns = document.querySelectorAll('.multicolumn .read-more');
  if (readMorBtns) { 
    readMorBtns.forEach(readMorBtn => {
      readMorBtn.addEventListener('click', function() { 
        const text = readMorBtn.closest(".multicolumn__text").querySelector(".rte");
        if (text.classList.contains('in-line--clamp')) {
          text.classList.remove("in-line--clamp");
          readMorBtn.textContent = "Read Less"
        }
        else { 
          text.classList.add("in-line--clamp");
          readMorBtn.textContent = "Read More"
        }
      });
    });
  }

  /** reviews, read more */
  const reviewReadMoreBtns = document.querySelectorAll('.testimonials .read-more');
  console.log(reviewReadMoreBtns);
  if (reviewReadMoreBtns) { 
    reviewReadMoreBtns.forEach(reviewReadMoreBtn => {
      reviewReadMoreBtn.addEventListener('click', function() { 
        const parent = reviewReadMoreBtn.closest(".content-wrapper");
        const fullText = parent.querySelector(".testimonial-text:not(.truncated-text)");
        const truncatedText = parent.querySelector(".testimonial-text.truncated-text");
        if (fullText.classList.contains('hidden')) { 
          fullText.classList.remove("hidden");
          truncatedText.classList.add("hidden");
          reviewReadMoreBtn.textContent = "Read Less"
        }
        else { 
          fullText.classList.add("hidden");
          truncatedText.classList.remove("hidden");
          reviewReadMoreBtn.textContent = "Read More"
        }
      });
    });
  }

  /** contact page, read more in reviews */
  const contactReadMoreBtns = document.querySelectorAll(".contact-content__container .testimonials-block");
  console.log(contactReadMoreBtns);

  /** multicolumn, positioning button */
  const sliderBtns = document.querySelectorAll('.multicolumn .slider-buttons'); 
  if(sliderBtns) { 
    sliderBtns.forEach(sliderBtn => { 
      const titleWrapper = sliderBtn.closest(".multicolumn").querySelector(".title-wrapper");
      const height = titleWrapper.offsetHeight;
      const computedStyle = window.getComputedStyle(titleWrapper);
      const marginBottom = parseFloat(computedStyle.marginBottom);
      const totalHeight = height + marginBottom;
      console.log(totalHeight);
      sliderBtn.style.top = `-${totalHeight}px`;
    });
  }
  
}

